import { render, staticRenderFns } from "./ModalVerDetalleAlta.vue?vue&type=template&id=ee971b24&"
import script from "./ModalVerDetalleAlta.vue?vue&type=script&lang=ts&"
export * from "./ModalVerDetalleAlta.vue?vue&type=script&lang=ts&"
import style0 from "./ModalVerDetalleAlta.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports